<div class="chat-mi-card">
  @for (group of groups; track group.basketItemId ?? $index) {
    <div class="chat-mi-card__product">
      @if (group.productName) {
        <div class="chat-mi-card__product-header">{{ group.productName }}</div>
      }

      @if (group.perBooking.length) {
        @if (group.perPassenger.length) {
          <div class="chat-mi-card__scope-label" i18n="@@chatMiPerBooking">Per Booking</div>
        }
        <ul class="chat-mi-card__list">
          @for (field of group.perBooking; track field.name) {
            <ng-container *ngTemplateOutlet="row; context: { field: field }"></ng-container>
          }
        </ul>
      }

      @if (group.perPassenger.length) {
        <div class="chat-mi-card__scope-label" i18n="@@chatMiPerPassenger">Per Passenger</div>
        <ul class="chat-mi-card__list">
          @for (field of group.perPassenger; track field.name) {
            <ng-container *ngTemplateOutlet="row; context: { field: field }"></ng-container>
          }
        </ul>
      }
    </div>
  }

  <button
    type="button"
    class="chat-mi-card__continue"
    (click)="onContinue()"
    i18n="@@chatMiConfirm"
  >
    Confirm
  </button>
</div>

<ng-template #row let-field="field">
  <li class="chat-mi-card__item">
    <div class="chat-mi-card__labelvalue">
      <span class="chat-mi-card__label chat-mi-card__label--plain">
        {{ field.name }}
        @if (field.mandatory) {
          <span class="chat-mi-card__required" aria-hidden="true">*</span>
        }
      </span>
      <span class="chat-mi-card__value" [class.chat-mi-card__value--empty]="!field.value">
        {{ field.value || '—' }}
      </span>
    </div>
    @if (field.locked) {
      <span
        class="chat-mi-card__lock"
        [attr.aria-label]="'Defaulted — not editable' | translate"
        role="img"
      >
        <fa-icon [icon]="faLock"></fa-icon>
      </span>
    } @else {
      <button
        type="button"
        class="chat-mi-card__edit"
        [disabled]="!field.id"
        (click)="onEdit(field)"
        [attr.aria-label]="'Edit ' + field.name | translate"
      >
        <fa-icon [icon]="faPenToSquare"></fa-icon>
      </button>
    }
  </li>
</ng-template>
